import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText, Shield, Scale } from 'lucide-react';

const LegalPage = () => {
  const [activeTab, setActiveTab] = useState('mentions');

  const tabs = [
    { id: 'mentions', label: 'Mentions légales', icon: FileText },
    { id: 'cgv', label: 'CGV', icon: Scale },
    { id: 'privacy', label: 'Politique de confidentialité', icon: Shield },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero */}
      <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white pt-32 pb-16">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
          <h1 className="text-3xl sm:text-5xl font-bold mb-4">Informations légales</h1>
          <p className="text-gray-400 text-lg">Transparence et confiance</p>
        </div>
      </section>

      {/* Tabs */}
      <div className="sticky top-20 bg-white border-b z-40">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
          <div className="flex gap-2 py-4 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                  activeTab === tab.id
                    ? 'bg-gray-900 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <tab.icon size={16} />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-[900px] mx-auto px-4 sm:px-6">
          <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-10">

            {/* Mentions légales */}
            {activeTab === 'mentions' && (
              <div className="prose prose-gray max-w-none">
                <h2 className="text-2xl font-bold mb-6">Mentions légales</h2>

                <h3 className="text-lg font-semibold mt-8 mb-4">1. Éditeur du site</h3>
                <p className="text-gray-600 mb-4">
                  <strong>Barham Driver</strong><br />
                  Service de VTC - Chauffeur privé<br />
                  Adresse : Rufisque cité Senelec villa 237, Sénégal<br />
                  Téléphone : +221 77 488 42 54<br />
                  Email : Sandierygassama8@gmail.com
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">2. Propriété intellectuelle</h3>
                <p className="text-gray-600 mb-4">
                  L'ensemble du contenu de ce site (textes, images, vidéos, logos) est la propriété exclusive de Barham Driver ou de ses partenaires. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">3. Responsabilité</h3>
                <p className="text-gray-600 mb-4">
                  Barham Driver s'efforce de fournir des informations aussi précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, inexactitudes et carences dans la mise à jour.
                </p>
              </div>
            )}

            {/* CGV */}
            {activeTab === 'cgv' && (
              <div className="prose prose-gray max-w-none">
                <h2 className="text-2xl font-bold mb-6">Conditions Générales de Vente</h2>

                <h3 className="text-lg font-semibold mt-8 mb-4">Article 1 - Objet</h3>
                <p className="text-gray-600 mb-4">
                  Les présentes conditions générales régissent les relations contractuelles entre Barham Driver et ses clients dans le cadre de prestations de transport VTC.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">Article 2 - Réservation</h3>
                <p className="text-gray-600 mb-4">
                  Les réservations peuvent être effectuées via notre site internet, par téléphone ou par WhatsApp. Une confirmation vous sera envoyée dans les meilleurs délais.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">Article 3 - Tarifs</h3>
                <p className="text-gray-600 mb-4">
                  Nos tarifs sont communiqués sur devis. Ils comprennent le transport, le chauffeur et le carburant. Les péages et parkings restent à la charge du client sauf accord contraire.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">Article 4 - Annulation</h3>
                <p className="text-gray-600 mb-4">
                  <strong>Annulation gratuite :</strong> jusqu'à 24h avant le départ prévu.<br />
                  <strong>Annulation tardive :</strong> moins de 24h avant, 50% du montant sera facturé.<br />
                  <strong>Non-présentation :</strong> 100% du montant sera facturé.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">Article 5 - Paiement</h3>
                <p className="text-gray-600 mb-4">
                  Le paiement s'effectue en espèces, par virement bancaire ou par mobile money. Pour les entreprises, un paiement à 30 jours peut être accordé sur demande.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">Article 6 - Bagages</h3>
                <p className="text-gray-600 mb-4">
                  Un nombre raisonnable de bagages est inclus. Pour un volume important, merci de nous prévenir lors de la réservation.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">Article 7 - Responsabilité</h3>
                <p className="text-gray-600 mb-4">
                  Barham Driver est assuré pour le transport de passagers. Notre responsabilité ne saurait être engagée en cas de retard dû à des circonstances indépendantes de notre volonté (embouteillages, conditions météorologiques, etc.).
                </p>
              </div>
            )}

            {/* Politique de confidentialité */}
            {activeTab === 'privacy' && (
              <div className="prose prose-gray max-w-none">
                <h2 className="text-2xl font-bold mb-6">Politique de confidentialité</h2>

                <h3 className="text-lg font-semibold mt-8 mb-4">1. Collecte des données</h3>
                <p className="text-gray-600 mb-4">
                  Nous collectons les informations que vous nous fournissez lors de vos réservations : nom, prénom, téléphone, email, adresses de prise en charge et de destination.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">2. Utilisation des données</h3>
                <p className="text-gray-600 mb-4">
                  Vos données sont utilisées uniquement pour :<br />
                  - Traiter vos réservations<br />
                  - Vous contacter concernant votre trajet<br />
                  - Améliorer nos services<br />
                  - Vous envoyer des informations commerciales (avec votre consentement)
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">3. Protection des données</h3>
                <p className="text-gray-600 mb-4">
                  Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données personnelles contre tout accès non autorisé.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">4. Conservation</h3>
                <p className="text-gray-600 mb-4">
                  Vos données sont conservées pendant la durée nécessaire à la gestion de notre relation commerciale et conformément aux obligations légales.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">5. Vos droits</h3>
                <p className="text-gray-600 mb-4">
                  Vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. Pour exercer ces droits, contactez-nous à Sandierygassama8@gmail.com.
                </p>

                <h3 className="text-lg font-semibold mt-8 mb-4">6. Cookies</h3>
                <p className="text-gray-600 mb-4">
                  Notre site utilise des cookies pour améliorer votre expérience de navigation. Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.
                </p>
              </div>
            )}

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalPage;
